import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getApiV1SiteConfig } from '@/api/sdk.gen'
import type { SiteConfig } from '@/api/types.gen'

export const useSiteConfigStore = defineStore(
  'site-config-store',
  () => {
    const config = ref<SiteConfig>({})

    const siteName = computed(() => config.value.site_name ?? '')
    const siteLogo = computed(() => config.value.site_logo ?? '')
    const customerServiceUrl = computed(() => config.value.customer_service_url ?? '')
    const bottomBtn1Name = computed(() => config.value.bottom_btn1_name ?? '')
    const bottomBtn1Url = computed(() => config.value.bottom_btn1_url ?? '')
    const bottomBtn2Name = computed(() => config.value.bottom_btn2_name ?? '')
    const bottomBtn2Url = computed(() => config.value.bottom_btn2_url ?? '')

    async function fetch() {
      const { data } = await getApiV1SiteConfig()
      if (data?.data) {
        config.value = data.data
      }
    }

    return {
      config,
      siteName,
      siteLogo,
      customerServiceUrl,
      bottomBtn1Name,
      bottomBtn1Url,
      bottomBtn2Name,
      bottomBtn2Url,
      fetch,
    }
  },
  { persist: true },
)
